const API_BASE_URL = 'https://acpong.llntnino.ru';
const API_VERSION = '/api/v1';

export const fetchProfileData = async (token, notificationState, offset, placeId) => {
  try {
    const response = await fetch(`${API_BASE_URL}/profile?offset=${offset}&place_id=${placeId}`, {
      method: 'GET',
      headers: {
        Authorization: `JWT ${token}`, // Передаем токен в заголовке запроса
      },
    });

    if (response.ok) {
      const profileData = await response.json();
      console.log('Профиль пользователя:', profileData);
      return profileData; // Возвращаем данные профиля
    } else {
      notificationState.openNotification(`Ошибка при получении профиля пользователя`, 'error');
      console.log('Ошибка при получении профиля пользователя');
      throw new Error('Ошибка при получении профиля пользователя');
    }
  } catch (error) {
    notificationState.openNotification(`'Ошибка при выполнении запроса. ${error}`, 'error');
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const fetchPlaceData = async (notificationState, place_id) => {
  try {
    let url = `${API_BASE_URL}/${API_VERSION}/place`;
    if (place_id) {
      url += `?place_id=${place_id}`;
    }
    const response = await fetch(url, {
      method: 'GET',
    });

    if (response.ok) {
      const placeData = await response.json();
      console.log('Информация о зале:', placeData);
      return placeData;
    } else {
      notificationState.openNotification(`Ошибка при получении информации о зале`, 'error');
      console.log('Ошибка при получении информации о зале');
      throw new Error('Ошибка при получении информации о зале');
    }
  } catch (error) {
    notificationState.openNotification(`'Ошибка при выполнении запроса. ${error}`, 'error');
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const fetchCitiesData = async (notificationState) => {
  try {
    let url = `${API_BASE_URL}/${API_VERSION}/city`;
    const response = await fetch(url, {
      method: 'GET',
    });

    if (response.ok) {
      const cityData = await response.json();
      console.log('Список городов:', cityData);
      return cityData;
    } else {
      notificationState.openNotification(`Ошибка при получении информации о городах`, 'error');
      console.log('Ошибка при получении информации о городах');
      throw new Error('Ошибка при получении информации о городах');
    }
  } catch (error) {
    notificationState.openNotification(`'Ошибка при выполнении запроса. ${error}`, 'error');
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const fetchBookingsForDay = async (token, selectedDay, notificationState, place_id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}/api/v1/profile/books?day=${selectedDay}&place_id=${place_id}`,
      {
        method: 'GET',
        headers: {
          Authorization: `JWT ${token}`, // Передаем токен в заголовке запроса
        },
      },
    );

    if (response.ok) {
      const DayBooks = await response.json();
      console.log('Брони дня:', DayBooks);
      return DayBooks; // Возвращаем данные профиля
    } else {
      notificationState.openNotification(`Ошибка при получении ваших броней`, 'error');
      console.log('Ошибка при получении ваших броней');
      throw new Error('Ошибка при получении ваших броней');
    }
  } catch (error) {
    notificationState.openNotification(`'Ошибка при выполнении запроса. ${error}`, 'error');
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const fetchTrainingsData = async (place_id) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/trainings?place_id=${place_id}`, {
      method: 'GET',
    });

    if (response.ok) {
      const trainingsData = await response.json();
      console.log('Профиль пользователя:', trainingsData);
      return trainingsData; // Возвращаем данные профиля
    } else {
      console.log('Ошибка при получении профиля пользователя');
      throw new Error('Ошибка при получении профиля пользователя');
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const fetchSubscriptionsData = async (place_id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}${API_VERSION}/subscriptions?place_id=${place_id}`,
      {
        method: 'GET',
      },
    );

    if (response.ok) {
      const subscriptionsData = await response.json();
      console.log('Доступные подписки:', subscriptionsData);
      return subscriptionsData; // Возвращаем данные профиля
    } else {
      console.log('Ошибка при получении доступных подписок');
      throw new Error('Ошибка при получении доступных подписок');
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const registerTransaction = async (reservations, token, notificationState) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/payment`, {
      method: 'POST',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bookings: reservations,
      }),
    });
    if (response.ok) {
      const data = await response.json();
      return data;
    } else if (response.status === 409) {
      notificationState.openNotification(
        `Упс! Кажется стол на это время уже забронирован. Обновите страницу.`,
        'error',
      );
      console.error('Такая бронь уже существует:', response.status);
    } else {
      const errorData = await response.json();
      notificationState.openNotification(`Ошибка при выполнении запроса. ${errorData}`, 'error');
      console.error('Ошибка при выполнении запроса:', errorData);
      throw new Error('Произошла ошибка при бронировании');
    }
  } catch (error) {
    notificationState.openNotification(`Ошибка при выполнении запроса. ${error}`, 'error');
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const sendReservations = async (token, status, notificationState) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/payment/resolve`, {
      method: 'POST',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(status),
    });
    if (response.ok) {
      notificationState.openNotification(`Бронь подтверджена! Ждём вас в клубе!`, 'success');
      return true; // Возвращаем true в случае успешного запроса
    } else if (response.status === 404) {
      notificationState.openNotification(
        `Ошибка при бронировании стола, транзакция не существует.`,
        'error',
      );
    } else if (response.status === 402) {
      notificationState.openNotification(
        `Ошибка при бронировании стола, оплата не произошла.`,
        'error',
      );
    } else if (response.status === 406) {
      notificationState.openNotification(
        `Ошибка при бронировании стола, сумма оплаты не соответсвует ожидаемой, обратитесь к администрации.`,
        'error',
      );
    } else if (response.status === 503) {
      notificationState.openNotification(
        `Ошибка ответа от банка. Ваша бронь заморожена, обратитесь к администрации`,
        'error',
      );
    }
  } catch (error) {
    notificationState.openNotification(
      `Ошибка при бронировании стола, обратитесь к администрации. Ошибка: ${error}`,
      'error',
    );
    console.error('Error sending reservations:', error);
    return false; // Возвращаем false в случае ошибки
  }
};

export const cancelBooking = async (token, bookingsToCancel, cancelForYear, notificationState) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/bookings`, {
      method: 'PATCH',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        bookings: bookingsToCancel,
        delete_all: cancelForYear,
      }),
    });
    if (response.ok) {
      notificationState.openNotification(`Бронь отменена.`, 'success');
    } else if (!response.ok) {
      // Обработка ошибок, если не удалось отменить бронирование
      console.error('Ошибка при отмене бронирования:', response.status, response.statusText);
    }
  } catch (error) {
    console.error('Ошибка при отмене бронирования:', error);
  }
};

export const purchaseSubscription = async (token, purchaseData) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/subscription/purchase`, {
      method: 'POST',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(purchaseData),
    });

    if (response.ok) {
      const data = await response.json();
      return data;
    } else {
      const errorData = await response.json();
      console.error('Ошибка при выполнении запроса:', errorData);
      throw new Error('Произошла ошибка при покупке абонемента');
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const handleSubcript = async (token, training) => {
  console.log(training);
  const data = {
    subscription_id: training.subscription_id,
    training_id: training.id,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/training/players`, {
      method: 'POST',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      console.log('Успех');
    } else if (response.status === 401) {
      throw new Error('Unauthorized'); // Бросаем ошибку при 401
    } else if (response.status === 406) {
      throw new Error('Already exists'); // Бросаем ошибку при 406
    } else {
      console.log('Не успех');
    }
  } catch (error) {
    console.log(error);
    throw error;
  }
};

export const createProfile = async (name, password, smsCode, token, notificationState) => {
  try {
    const data = { name, password, smsCode };
    const response = await fetch('https://acpong.llntnino.ru/profile', {
      method: 'POST',
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      console.log('Регистрация успешна!');
      notificationState.openNotification('Регистрация успешна!', 'success');
      return true;
    } else {
      // Обработка конкретных кодов ошибок
      if (response.status === 406) {
        notificationState.openNotification(`Произошла ошибка при регистрации профиля`, 'error');
      } else if (response.status === 409) {
        notificationState.openNotification(
          `Пользователь с таким телефоном уже существует`,
          'error',
        );
      } else if (response.status === 403) {
        notificationState.openNotification(
          `Вы ввели неверный код или его время жизни вышло (10 минут)`,
          'error',
        );
      } else {
        notificationState.openNotification(
          `Произошла неизвестная ошибка при регистрации. Код: ${response.status}`,
          'error',
        );
      }
    }
  } catch (error) {
    notificationState.openNotification(
      `Произошла ошибка при выполении запроса к серверу. Ошибка: ${error}`,
      'error',
    );
    console.error('Ошибка при выполнении запроса:', error);
  }
};

export const resetPassword = async (password, smsCode, token, notificationState) => {
  try {
    const data = { password, smsCode };
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/reset`, {
      method: 'POST',
      headers: {
        Authorization: `${token}`,
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });
    if (response.ok) {
      console.log('Cмена пароля прошла успешно!');
      notificationState.openNotification('Cмена пароля прошла успешно!', 'success');
      return true;
    } else {
      // Обработка конкретных кодов ошибок
      if (response.status === 406) {
        notificationState.openNotification(`Произошла ошибка при смене пароля`, 'error');
      } else if (response.status === 403) {
        notificationState.openNotification(
          `Вы ввели неверный код или его время жизни вышло (10 минут)`,
          'error',
        );
      } else {
        notificationState.openNotification(
          `Произошла неизвестная ошибка при регистрации. Код: ${response.status}`,
          'error',
        );
      }
    }
  } catch (error) {
    notificationState.openNotification(
      `Произошла ошибка при выполении запроса к серверу. Ошибка: ${error}`,
      'error',
    );
    console.error('Ошибка при выполнении запроса:', error);
  }
};

export const sendPreauthSms = async (phone, notificationState, recaptchaValue) => {
  const data = {
    phone: phone,
    recaptcha: recaptchaValue,
  };
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/send_sms`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(data),
    });

    if (response.ok) {
      notificationState.openNotification(
        `Смс отправлена на указанный номер. Введите код в соответсвующее поле`,
        'success',
      );
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 425) {
      const errorMessage = await response.json();
      notificationState.openNotification(`Слишком быстро. Дождитесь ${errorMessage}.`, 'error');
    } else if (response.status === 422) {
      notificationState.openNotification(
        `Введенный номер телефона не похож на настоящий, попробуйте другой.`,
        'error',
      );
    } else if (response.status === 412) {
      notificationState.openNotification(
        `Вы подозрительно быстро нажимаете кнопки. Гугл считает вас роботом.`,
        'error',
      );
    } else if (response.status === 409) {
      notificationState.openNotification(
        `Пользователь с таким номером телефона уже существует.`,
        'error',
      );
    } else if (response.status >= 500) {
      notificationState.openNotification(`Кажется проблема с сервером, попробуйте позже.`, 'error');
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const sendResetSms = async (phone, notificationState, recaptchaValue) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}${API_VERSION}/reset?phone=${phone.replace(
        '+',
        '%2B',
      )}&recaptcha=${recaptchaValue}`,
      {
        method: 'GET',
      },
    );

    if (response.ok) {
      notificationState.openNotification(
        `Смс отправлена на указанный номер. Введите код в соответсвующее поле`,
        'success',
      );
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 425) {
      const errorMessage = await response.json();
      notificationState.openNotification(`Слишком быстро. Дождитесь ${errorMessage}.`, 'error');
    } else if (response.status === 422) {
      notificationState.openNotification(
        `Введенный номер телефона не похож на настоящий, попробуйте другой.`,
        'error',
      );
    } else if (response.status === 412) {
      notificationState.openNotification(
        `Вы подозрительно быстро нажимаете кнопки. Гугл считает вас роботом.`,
        'error',
      );
    } else if (response.status === 409) {
      notificationState.openNotification(
        `Пользователь с таким номером телефона не существует.`,
        'error',
      );
    } else if (response.status >= 500) {
      notificationState.openNotification(`Кажется проблема с сервером, попробуйте позже.`, 'error');
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const openTheDoor = async (notificationState, token, place_id) => {
  console.log(token);
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/open?place_id=${place_id}`, {
      method: 'GET',
      headers: {
        Authorization: `JWT ${token}`,
      },
    });

    if (response.ok) {
      notificationState.openNotification(`Дверь была открыта`, 'success');
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 404) {
      notificationState.openNotification(`Вы не можете сейчас попасть в зал`, 'error');
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const openSharedDoor = async (notificationState, pwd, place_id) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}${API_VERSION}/shared/open?pwd=${pwd}&place_id=${place_id}`,
      {
        method: 'GET',
      },
    );

    if (response.ok) {
      notificationState.openNotification(`Дверь была открыта`, 'success');
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 404) {
      notificationState.openNotification(`Вы не можете сейчас попасть в зал`, 'error');
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const getSharedBookLink = async (bookingId, notificationState, token) => {
  const data = {
    book_id: bookingId,
  };
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/shared/book`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 403) {
      notificationState.openNotification(
        `Бронь принадлежит не вам, обратитесь к администрации`,
        'error',
      );
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const getSharedBookInfo = async (pwd, notificationState) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/shared/book?pwd=${pwd}`, {
      method: 'GET',
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 403) {
      notificationState.openNotification(
        `Бронь принадлежит не вам, обратитесь к администрации`,
        'error',
      );
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const getMerchantId = async (place_id, token, notificationState) => {
  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/merchant?place_id=${place_id}`, {
      method: 'GET',
      headers: {
        Authorization: `JWT ${token}`,
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 404) {
      notificationState.openNotification(
        `Не найден идентификатор продавца. Обратитесь к администрации`,
        'error',
      );
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const getSchemaForPlace = async (place_id, token, notificationState) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}${API_VERSION}/place/schema?place_id=${place_id}`,
      {
        method: 'GET',
        headers: {
          Authorization: `JWT ${token}`,
        },
      },
    );

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 404) {
      notificationState.openNotification(`Схема зала не найдена`, 'error');
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};

export const getLightsState = async (place_id, token, notificationState) => {
  try {
    const response = await fetch(
      `${API_BASE_URL}${API_VERSION}/lights/state?place_id=${place_id}`,
      {
        method: 'GET',
        headers: {
          Authorization: `JWT ${token}`,
        },
      },
    );

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 404) {
      notificationState.openNotification(`Зал с таким id не найден`, 'error');
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    notificationState.openNotification(
      `Ошибка при получении статуса умного света. <br> ${error}`,
      'error',
    );
    throw error;
  }
};

export const updateLightsState = async (place_id, token, notificationState, state) => {
  const data = {
    state,
    place_id: place_id,
  };

  try {
    const response = await fetch(`${API_BASE_URL}${API_VERSION}/lights/state`, {
      method: 'POST',
      body: JSON.stringify(data),
      headers: {
        Authorization: `JWT ${token}`,
        'Content-Type': 'application/json',
      },
    });

    if (response.ok) {
      const responseData = await response.json();
      return responseData;
    } else if (response.status === 404) {
      notificationState.openNotification(
        `Вы не можете управлять светом на этом столе. <br>`,
        'error',
      );
      throw false;
    } else if (response.status >= 500) {
      const errorMessage = await response.json();
      notificationState.openNotification(
        `Кажется проблема с сервером, попробуйте позже. ${errorMessage}`,
        'error',
      );
      throw false;
    }
  } catch (error) {
    console.error('Ошибка при выполнении запроса:', error);
    throw error;
  }
};
